import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
import {
  ButtonGroupWrapper,
  StyledButton,
  StyledBackground,
} from "./BtnGroup.styles"

const BtnGroup = ({ buttonList, onChange, ...rest }) => {
  const [selected, setSelected] = useState("both")
  const [backgroundWidth, setBackgroundWidth] = useState(0)
  const [backgroundPosition, setBackgroundPosition] = useState(0)

  const buttonGroup = useRef(null)

  useEffect(() => {
    const element = buttonGroup.current.children[0]
    setBackgroundWidth(element.offsetWidth)
  }, [])

  const handleChange = (index, value, event) => {
    event.preventDefault()
    const element = buttonGroup.current.children[index]
    setBackgroundWidth(element.offsetWidth)
    setBackgroundPosition(element.offsetLeft)
    setSelected(value)

    onChange(value)
  }

  return (
    <ButtonGroupWrapper ref={buttonGroup} data-testid="buttonGroupWrapper">
      {buttonList.map((button, index) => (
        <StyledButton
          key={button.text}
          {...rest}
          onClick={(event) => handleChange(index, button.value, event)}
          isActive={selected === button.value}
          data-testid="buttonGroupButton"
        >
          {button.text}
        </StyledButton>
      ))}
      <StyledBackground
        backgroundPosition={backgroundPosition}
        backgroundWidth={backgroundWidth}
      />
    </ButtonGroupWrapper>
  )
}

BtnGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  buttonList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
}

export default BtnGroup
